var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowSmDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 10.6953L12.6665 0.303006H0.666504L6.6665 10.6953Z",
    fill: "#BC2525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowSmDanger);
export default __webpack_public_path__ + "static/media/down-arrow-sm-danger.c263b54f3e5316188afbe59d7d5c4d2d.svg";
export { ForwardRef as ReactComponent };